import * as React from 'react'

import GroupByPanel from '../panels/GroupByPanel'
import { IGroupByPanelProps } from '../types'
import OptionsPopoverShell from './OptionsPopoverShell'

interface IProps extends Omit<IGroupByPanelProps, 'onClose'> {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
}

const GroupByPopover: React.FC<IProps> = ({
  open,
  onOpenChange,
  children,
  side,
  align,
  sideOffset,
  ...panelProps
}) => {
  return (
    <OptionsPopoverShell
      open={open}
      onOpenChange={onOpenChange}
      trigger={children}
      side={side}
      align={align}
      sideOffset={sideOffset}
    >
      <GroupByPanel {...panelProps} onClose={() => onOpenChange(false)} />
    </OptionsPopoverShell>
  )
}

export default GroupByPopover
